import { Global } from './assets/styles/Global';
import { Reset } from './assets/styles/Reset';
import { PostProvider } from './providers/PostContext';
import { UserProvider } from './providers/UserContext';
import { RoutesMain as Routes } from './routes';


function App() {
  return (
    <>
      <Global />
      <Reset />
      <UserProvider>
        <PostProvider>
          <Routes />
        </PostProvider>
      </UserProvider>
    </>
  );
}

export default App;
